@if (model.view.showContactYourDealer!== null && model.view.showContactYourDealer) {
  <main class="container-skyscraper-ad"
    >
    Bitte wenden Sie sich an den Händler.
  </main>
}

@if (cookieService.cookieAsked) {
  <main id="container-skyscraper"
    class="container-skyscraper"
    >
    @if (calculating) {
      <div class="busy"
      ></div>
    }
    <!--            (ngSubmit)="form.valid && onSubmit()"-->
    <form name="form"
      #form="ngForm"
      class="o-layout  o-layout--stretch  o-layout--flush"
          ngxTippy
      novalidate>
      <div id="errormessage" class="o-layout__item  u-5/5@m" style="color: red"><strong>{{model.view.errortext}}</strong></div>
      @if (!model.view.errortext) {
        <div class="o-layout__item  u-3/5@m">
          <div class="o-box">
            <h2>Ihre Wunschfinanzierung</h2>
            <fieldset class="c-selector c-selector--flushed u-margin-bottom-small" id="contract-kind">
              <legend class="c-selector__title  c-form-label">
                Finanzierungsart
                <span class="c-icon c-icon--information as-tooltip-trigger" id="iconTooltipContractKind" #tooltipIcon
                      [tooltip]="getTooltipContractKind()" tabindex="0">
                </span>
              </legend>
              <div class="c-selector__items">
                @for (c of model.view.conditions; track c; let index = $index) {
                  <input id="contractKind_{{c.contractKindCode}}" name="contractKind_{{c.contractKindCode}}" class="c-selector__input" type="radio"
                    required [value]="c" (change)="changeContractKind(model.settings.contractKind) ; resetResult();"
                    [(ngModel)]="model.settings.contractKind">
                  <label class="c-selector__label" for="contractKind_{{c.contractKindCode}}">{{c.contractKindDescription}}</label>
                }
              </div>
            </fieldset>
            <div class="u-margin-bottom-small">
              <fieldset class="c-selector u-margin-bottom-small">
                <div class="c-selector__title">
                  <legend class="c-selector__title  c-form-label">
                    Laufzeit in Monaten
                  </legend>
                </div>
                <div class="c-selector__items">

                  @for (l of model.settings.contractKind?.durationsValues; track l; let index = $index) {
                    <input id="duration.value_{{l}}" name="duration.value_{{l}}" class="c-selector__input" type="radio"
                      required [value]="l" (change)="calculateRate()"
                      [(ngModel)]="model.settings.duration">
                    <label class="c-selector__label u-flex-grow-0" for="duration.value_{{l}}">{{l}}</label>
                  }
                </div>
              </fieldset>
            </div>
            <div class="o-layout  u-margin-bottom-small">
              <div class="o-layout__item  u-1/2@s">
                <label for="prepayment.value" class="c-selector__title  c-form-label">
                  {{isLeasing() ? 'Sonderzahlung' : 'Anzahlung'}}
                </label>
                <div class="c-text-input  c-text-input--small">
                  <input id="prepayment.value"
                    [(ngModel)]="model.settings.prepaymentPrice"
                    onClick="this.setSelectionRange(0, this.value.length)"
                    name="prepaymentPrice"
                    type="text"
                    class="c-text-input__input"
                    rci-number-format
                    maxlength="20"
                    pattern="[\-0-9,.]*"
                    autocomplete="off"
                    (change)="prepaymentPriceGetSetEvent($event.target);rangeChanged()"
                    [placeholder]="getPlaceholderPrepaymentPrice()"
                    required>
                  <span class="c-text-input__addon">EUR</span>
                </div>
              </div>
            </div>
            @if (model.settings.contractKind && model.settings.contractKind.balloon === true || isLeasing()) {
              <label class="c-selector__title  c-form-label">
                Laufleistung p. a.
              </label>
            }
            @if (model.settings.contractKind?.balloon === true || isLeasing()) {
              <nouislider [config]="getSliderConfig()"
                [step]="10000" [(ngModel)]="model.settings.mileage" (change)="calculateRate()"
                name="mileageValue">
              </nouislider>
            }
          </div>
        </div>
      }
      @if (!model.view.errortext) {
        <div class="o-layout__item  u-2/5@m">
          <div class="o-box  u-bg-off-white">
            <h2 class="u-margin-bottom-small">Ergebnis</h2>
            <p class="u-margin-bottom-none  u-text-size-2">z.B. monatlich
              <span class="c-icon c-icon--information  as-tooltip-trigger" id="iconTooltipContentInfo" #tooltipIcon
              [tooltip]="tooltipContentInfo()" tabindex="0"></span>
            </p>
            <div class="o-split  o-split--bottom  u-margin-bottom-small">
              <div class="o-split__item">
                <span class="c-price  c-price--highlight  c-price--emphasize">
                  @if (!model.view.currentResult || !model.view.currentResult.rate) {
                    <span class="c-price__price">-,--</span>
                  }
                  @if (model.view.currentResult && model.view.currentResult.rate) {
                    <span class="c-price__price">{{ model.view.currentResult.rate | currency:'€' }}</span>
                  }
                </span>
              </div>
              <div class="o-split__item">
                <button class="c-icon  c-icon--print" aria-label="Angebot drucken" (click)="form.invalid || printPdf()"></button>
              </div>
            </div>
            <div class="u-margin-bottom-small">
              <dl class="c-definition-list">
                <dt>Fahrzeugpreis</dt>
                <dd id="vehicle-price.value">{{parseFloatDe(model.view.totalVehiclePrice) | currency:'€'}}</dd>
                @if ((model.settings.contractKind?.balloon === true) && isFinancing()) {
                  <dt id="result.finalrate.label">Schlussrate</dt>
                }
                @if ((model.settings.contractKind?.balloon === true) && isFinancing() && model.view.currentResult) {
                  <dd id="result.finalrate.value"
                  >{{ model.view.currentResult.residualValuePrice | currency:'€' | defaultIfNull}}</dd>
                }
                @if (!isLeasing()) {
                  <dt id="result.netloanamount.label">Nettodarlehensbetrag:</dt>
                }
                @if (!isLeasing()) {
                  <dd id="result.netloanamount.value">{{getTotalLoanAmount() | currency:'€' | defaultIfNull}}</dd>
                }
                <dt id="annual.percentage.rate.label">Effektiver Jahrszins</dt>
                @if (model.view.currentResult) {
                  <dd id="annual.percentage.rate.value">{{ model.view.currentResult.effectiveInterestPercent | currency:'%' }}</dd>
                }
                <dt id="result.interest.on.debt.label">Sollzins (gebunden) p.a.</dt>
                @if (model.view.currentResult) {
                  <dd id="result.interest.on.debt.value">{{ model.view.currentResult.nominalInterestPercent | currency:'%' | defaultIfNull}}</dd>
                }
                <dt id="result.ratetotalamountvalue.label">Gesamtbetrag der Raten:</dt>
                @if (model.view.currentResult) {
                  <dd id="result.ratetotalamountvalue.value">{{ model.view.currentResult.totalRatePrice | currency: '€' | defaultIfNull }}</dd>
                }
              </dl>
            </div>
            <div class="u-margin-bottom-small" [hidden]="!model.view.showSolvency || model.view.showInvalidCondition">
              <button class="c-btn  c-btn--full"
                      type="submit"
                      id="button.solvency"
                      (click)="preAcceptance()"
                      [disabled]="model.view.errortext">
                <span class="c-btn__label">
                  Anfrage stellen
                </span>
              </button>
            </div>
            <div class="o-right">
              <div class="o-right__item">
                <p class="u-margin-bottom-none  u-text-size-2">
                  <a class="u-text-color-link" target="_blank" href="{{environment.budgetcalcUrl}}/privacycustomer?brand={{model.view.brand}}" tabindex="0">
                    Datenschutzhinweise
                  </a>
                </p>
              </div>
              <div class="o-right__item">
                <p class="u-margin-bottom-none  u-text-size-2">
                  @if (model.view.brand == 'REN') {
                    <a class="u-text-color-link" target="_blank" href="https://www.mobilize-fs.de/impressum" tabindex="0">
                      Impressum
                    </a>
                  }
                  @if (model.view.brand == 'DAC') {
                    <a class="u-text-color-link" target="_blank" href="https://www.mobilize-fs.de/impressum" tabindex="0">
                      Impressum
                    </a>
                  }
                  @if (model.view.brand == 'NIS') {
                    <a class="u-text-color-link" target="_blank" href="https://nissan-bank.de/rechtliche-hinweise/impressum" tabindex="0">
                      Impressum
                    </a>
                  }
                  @if (model.view.brand == 'RCI') {
                    <a class="u-text-color-link" target="_blank" href="https://www.rcibanque.de/meta/impressum" tabindex="0">
                      Impressum
                    </a>
                  }
                </p>
              </div>
            </div>
          </div>
        </div>
      }
    </form>
  </main>
}

